import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  ORDERLOCATIONS_TEMPLATE,
  ORDERLOCATIONS_TEMPLATE_ADD,
  ORDERLOCATIONS_TEMPLATE_DELETE,
  GET_Location_TEMPLATE_ROW_DATA,
} from "./action.types";

import {
  apiError,
  getORDERLocationsTemplate,
  ORDERlocationTemplateListSuccessful,
  locationAddTemplateSuccessful,
  locationRowDataTemplateSuccessful,
  model_close,
} from "./actions";

import {
  postAdd,
  putImg,
  getList,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getORDERLocationTemplate({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/masters/orderlocationtemplates/",
      params
    );

    yield put(ORDERlocationTemplateListSuccessful({ response }));
    // yield put(changeSidebarTypeAction("icon"));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetOrderLocationRowDataTemplate({ payload: { LocId } }) {
  try {
    const response = yield call(
      getList,
      "/masters/orderlocationtemplates/" + LocId,
      {}
    );
    yield put(
      locationRowDataTemplateSuccessful({
        response: {
          ...response,
          image: response.image
            ? response.image
            : {
                name: "",
                url: "",
                preview: "",
                type: "",
                size: 0,
              },
          locationsLabel: response.location ? response.location.name : "",
          location_id: response.location ? response.location.id : "",
          sublocationLabel: response.sublocation
            ? response.sublocation.name
            : "",
          sublocation_id: response.sublocation ? response.sublocation.id : "",
        },
      })
    );
  } catch (error) {
    // swal(error[0], {
    //   icon: "error",
    //   timer: 1500,
    // });
    yield put(apiError(error));
  }
}

function* ADDORDERLOCATIONSTEMPLATE({
  payload: { data, image, fileType, LoId, history, model },
}) {
  delete data.image;

  try {
    if (!LoId) {
      // ADD CASE
      const response = yield call(postAdd, "/masters/orderlocationtemplates/", data);

      if (response.status === 201) {
        if (image) {
          console.log(image, "PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP");
          console.log(fileType, "fileType");
          const response2 = yield call(
            putImg,
            `/masters/orderlocationtemplates/${response.data.id}`,
            {
              file: image,
              name: "image", // ✅ dynamic field name
            }
          );
          console.log(response2, "PPPPPPP444444444444444444444");

          if (response2.status === 200) {
            swal("Your Order Location Added Successfully!", {
              icon: "success",
              timer: 1500,
            });
            if (model) {
              yield put(getORDERLocationsTemplate());
            } else {
              history.push("/OrderLocationTemplate");
            }
          } else {
            swal("Unable to upload file. Please try again!", {
              icon: "error",
              timer: 1500,
            });
          }
        } else {
          swal("Your Order Location Added Successfully!", {
            icon: "success",
            timer: 1500,
          });
          if (model) yield put(getORDERLocationsTemplate());
          else history.push("/OrderLocationTemplate");
        }
      } else {
        swal("Unable to add Order Location. Please try again!", {
          icon: "error",
          timer: 1500,
        });
      }

      yield put(locationAddTemplateSuccessful(null));
    } else {
      // EDIT CASE
      const response = yield call(
        postEdit,
        `/masters/orderlocationtemplates/${LoId}`,
        data
      );

      if (response.status === 200) {
        if (image) {
          console.log(image, "PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP");
          console.log(fileType, "fileType");

          const response2 = yield call(
            putImg,
            `/masters/orderlocationtemplates/${response.data.id}`,
            {
              file: image,
              name: "image", // ✅ dynamic field name
            }
          );
          console.log(response2, "PPPPPPP444444444444444444444");

          if (response2.status === 200) {
            swal("Your Order Location Updated Successfully!", {
              icon: "success",
              timer: 1500,
            });
            if (model) yield put(getORDERLocationsTemplate());
            else history.push("/OrderLocationTemplate");
          } else {
            swal("Unable to upload file. Please try again!", {
              icon: "error",
              timer: 1500,
            });
          }
        } else {
          swal("Your Order Location Updated Successfully!", {
            icon: "success",
            timer: 1500,
          });
          if (model) yield put(getORDERLocationsTemplate());
          else history.push("/OrderLocationTemplate");
        }
      } else {
        swal("Unable to update Order Location. Please try again!", {
          icon: "error",
          timer: 1500,
        });
      }

      yield put(locationAddTemplateSuccessful(null));
    }
  } catch (err) {
    console.error("PUTIMG ERROR:", err);

    let backendData =
      err?.response?.data || // axios error
      err; // plain object error (your case)

    let message = "Something went wrong";
    console.log(backendData, "backendData");
    // If backend returned object like {name: ['error']}
    if (backendData && typeof backendData === "object") {
      const firstKey = Object.keys(backendData)[0];
      const firstValue = backendData[firstKey];

      if (Array.isArray(firstValue)) {
        message = firstValue[0];
      } else if (typeof firstValue === "string") {
        message = firstValue;
      }
    }

    swal(message, { icon: "error", timer: 2000 });
    return;
  }
}

function* DeleteORDERLOCATIONSTEMPLATE({ payload: { locId } }) {
  try {
    const response = yield call(postDelete, "/masters/orderlocationtemplates/" + locId);
    if (response.status === 204) {
      swal("Poof! Your Product has been deleted!", {
        icon: "success",
      });
      yield put(getORDERLocationsTemplate());
    } else {
      swal("Sorry! Your Product has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal(error, {
      icon: "error",
    });

    //yield put(apiError(error));
  }
}

//_______________END____________//

export function* watchgetORDERLocationsTemplate() {
  yield takeEvery(ORDERLOCATIONS_TEMPLATE, getORDERLocationTemplate);
}

export function* watchADDORDERLOCATIONSTEMPLATEAdd() {
  yield takeEvery(ORDERLOCATIONS_TEMPLATE_ADD, ADDORDERLOCATIONSTEMPLATE);
}

export function* watchORDERLOCATIONSTEMPLATEDelete() {
  yield takeEvery(ORDERLOCATIONS_TEMPLATE_DELETE, DeleteORDERLOCATIONSTEMPLATE);
}

export function* watchORDERLOCATIONSRowDataTemplate() {
  yield takeEvery(GET_Location_TEMPLATE_ROW_DATA, GetOrderLocationRowDataTemplate);
}

function* ORDERLOCATIONSTemplateSaga() {
  yield all([
    fork(watchgetORDERLocationsTemplate),
    fork(watchADDORDERLOCATIONSTEMPLATEAdd),
    fork(watchORDERLOCATIONSTEMPLATEDelete),
    fork(watchORDERLOCATIONSRowDataTemplate),
  ]);
}

export default ORDERLOCATIONSTemplateSaga;
